(function () {
    document.querySelectorAll('.category-tabs').forEach(function (tabs) {
        const page = tabs.closest('.category-page');
        if (!page) return;

        // Every header and grid block carries a matching data-scope
        // attribute (see partials/category-scope-header.hbs /
        // category-scope-grid.hbs). Toggling all of them together, keyed
        // off the same comparison, is what guarantees a header and its
        // grid can never end up showing different scopes.
        const scopedEls = page.querySelectorAll('[data-scope]');
        const tabLinks = tabs.querySelectorAll('.category-tab');

        tabLinks.forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                const target = link.getAttribute('data-tab-target');

                tabLinks.forEach(function (l) {
                    l.classList.toggle('is-active', l === link);
                });

                scopedEls.forEach(function (el) {
                    el.hidden = el.getAttribute('data-scope') !== target;
                });

                history.replaceState(null, '', link.getAttribute('href'));
            });
        });
    });
})();
